/**
 * Business calendar dates — the frontend twin of backend/cutoff.py's
 * today_ist() / tomorrow_ist().
 *
 * Every "today" / "tomorrow" / "yesterday" the app sends to or compares with
 * the backend is the calendar date in the application's time zone (IST), not
 * the UTC date `new Date().toISOString().slice(0, 10)` produces — that one
 * still reads as the PREVIOUS day between 00:00 and 05:30 IST, so a 05:00
 * rider or admin saw yesterday's orders under "Today".
 *
 * The zone is resolved by the platform's Intl time-zone data rather than a
 * hand-applied offset, so the result is correct whatever zone the device
 * itself is set to.
 */
export const APP_TIME_ZONE = "Asia/Kolkata";

let _fmt = null;
function formatter() {
  if (!_fmt) {
    _fmt = new Intl.DateTimeFormat("en-US", {
      timeZone: APP_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
    });
  }
  return _fmt;
}

/** YYYY-MM-DD of `d` (a Date or epoch ms) on the IST calendar. */
export function istDateISO(d = new Date()) {
  const parts = formatter().formatToParts(d instanceof Date ? d : new Date(d));
  const get = (type) => parts.find((p) => p.type === type)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

/** Pure calendar arithmetic on a YYYY-MM-DD string (no clock involved). */
export function addDaysISO(iso, days) {
  const [y, m, d] = String(iso).split("-").map((x) => parseInt(x, 10));
  return new Date(Date.UTC(y, (m || 1) - 1, (d || 1) + days)).toISOString().slice(0, 10);
}

export const todayIST = (now = new Date()) => istDateISO(now);
export const tomorrowIST = (now = new Date()) => addDaysISO(istDateISO(now), 1);
export const yesterdayIST = (now = new Date()) => addDaysISO(istDateISO(now), -1);
/** IST date `days` away from today (negative = past). */
export const shiftIST = (days, now = new Date()) => addDaysISO(istDateISO(now), days);
